import { Component, OnInit } from '@angular/core';
import { UserService } from "../../shared/services/user.service";

@Component({
  selector: 'app-active-directory',
  templateUrl: './active-directory.component.html'
})
export class ActiveDirectoryComponent implements OnInit {
  isPractitionerActive: boolean;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.isPractitionerActive = !this.userService.isCurrentUserInactive;
  }
}